export const platform = {
  ios: 'iOS',
  android: 'android',
  mweb: 'mweb',
  web: 'web',
};

export const vendors = {
  pharmeasy: 'pharmeasy',
};

export const cookieNames = {
  WEBVIEW_COOKIE: 'X-WebView',
  PHONE_PLATFORM_COOKIE: 'X-Phone-Platform',
  VENDOR_COOKIE: 'X-Vendor',
};

export const userAgents = {
  android: 'PeAndroid',
  ios: 'PeiOS',
};

export const mediaPermissionsStatusMapping = {
  GRANTED: 'granted',
  PROMPT: 'prompt',
  DENIED: 'denied',
};
